import MiddlewareBase from "@/router/middleware/MiddlewareBase";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import AuthController from "@/controllers/global/AuthController";
import { ModuleList } from "@/models/settings/ModuleList";

export default class ModuleMiddleware extends MiddlewareBase {
	public moduleId: ModuleList;

	constructor(moduleId: ModuleList) {
		super();
		this.moduleId = moduleId;
	}

	public async execute(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
		try {
			if (AuthController.hasModuleAccess(this.moduleId)) {
				return true;
			} else {
				next({ name: "moduleAccessDenied" });
				return false;
			}
		} catch (error: any) {
			console.error("module auth error", error);
			return false;
		}
	}
}
